var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.propagationContent === 'web')?_c('AdDesignWeb',{attrs:{"id":_vm.id,"disabled":!_vm.canEdit,"next-route":_vm.nextRoute,"prev-route":_vm.prevRoute,"store-namespace":_vm.storeNamespace}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }